import log from '../log';
import {CONTEXT_VIEW_KEY} from '../symbols';

export default function createOnStateChangeArgs(
	useCoeffectsLikeObjectInView,
	componentId,
	state,
	context,
	helpers,
	host
) {
	if (useCoeffectsLikeObjectInView) {
		const {properties} = state;
		const stateSansProperties = {...state};
		delete stateSansProperties.properties;

		return [{state: stateSansProperties, properties, context, ...helpers, host}, undefined];
	}

	let contextKey = 'context';
	if (state.context) {
		contextKey = CONTEXT_VIEW_KEY;
		const message =
			'A "context" property key already exists in the view derived state object. The context value was assigned to a symbol.' +
			' The symbol constant, "contextViewKey", can imported from @servicenow/ui-core.';
		log(message, {host, origin: 'createOnStateChangeArgs'});
	}

	return [{componentId, ...state, [contextKey]: context}, helpers];
}
